import './Footer.css';
import React from 'react';

const Footer = () => {
  return (
    <p className='footer'>built by <a href='https://instagram.com/who.i.why' target='_blank'>who i why</a> ₍^. .^₎⟆</p>
  )
};

export default Footer;